<script setup lang="ts">
  import { computed } from 'vue';
  import { useShared, useTranslator } from '@othercommerce/foundation';

  const shared = useShared();
  const translator = useTranslator();
  const name = computed(() => shared.value.appName || 'Promoznawcy');
  const from = computed(() => shared.value.appCreationYear || 2024);
  const to = (new Date()).getFullYear();

  const message = computed(() => {
    if (from.value != to) {
      return translator.trans('SHOP.COMMON.MESSAGE.COPYRIGHTS_RANGE', { name: name.value, from: from.value, to });
    } else {
      return translator.trans('SHOP.COMMON.MESSAGE.COPYRIGHTS', { name: name.value, from: from.value });
    }
  });
</script>
<template>
  <p v-html="message" />
</template>
